document.addEventListener('DOMContentLoaded', function() {

  function smoothScroll(triggerSelector, targetSelector, offset = 100) {
    const triggers = document.querySelectorAll(triggerSelector);
  
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
  
        // find the closest section (so it scrolls to the correct slider in that section)
        const section = trigger.closest('section') || document;
  
        const target = section.querySelector(targetSelector);
        if (!target) return;
  
        const targetY =
          target.getBoundingClientRect().top + window.pageYOffset - offset;
  
        window.scrollTo({
          top: targetY,
          behavior: 'smooth'
        });
      });
    });
  }
  
 
  // Existing link
  smoothScroll('.see-full-faq', '.faq-split-section');
  
  // New link
  smoothScroll('.hp-1-ingredients', '.hp1-ing-wrapper');

  smoothScroll('.lp-hero-rating', '.lp-test-slider-wrap');
  smoothScroll('.lp-product-purchase__rating', '.lp-test-slider-wrap');

});

(function(){

  var header = document.querySelector('.lp-header-announcement');
  var hero = document.querySelector('main > section:first-child') || document.querySelector('.shopify-section:first-child');

  if(!header || !hero) return;

  var lastScroll = window.pageYOffset;
  var scrollThreshold = 6; // ignore tiny scroll movements

  function getHeroBottom(){
    var rect = hero.getBoundingClientRect();
    return rect.bottom + window.pageYOffset;
  }

  var heroBottom = getHeroBottom();

  window.addEventListener('resize', function(){
    heroBottom = getHeroBottom();
  });

  window.addEventListener('scroll', function(){

    var currentScroll = window.pageYOffset;
    var scrollDiff = Math.abs(currentScroll - lastScroll);

    if(scrollDiff < scrollThreshold) return;

    // console.log(currentScroll)
    if(currentScroll < 900) {
        header.classList.remove('header-sticky');
    } else {
        // scrolling DOWN
        header.classList.add('header-sticky');

    }

    if(currentScroll > heroBottom){

      if(currentScroll > lastScroll){
        // scrolling UP
        header.classList.add('header-visible');
      } else {
        // scrolling DOWN
        // header.classList.remove('header-visible');
      }

    }else{
      header.classList.remove('header-visible');
    }

    lastScroll = currentScroll;

  }, { passive: true });

})();

window.onload = function() {
  (function () {
    const COLLAPSED_HEIGHT = 120;
  
    function initSeeMore() {
      document.querySelectorAll('.product-custom-description').forEach(wrapper => {
        const content = wrapper.querySelector('.metafield-rich_text_field');
        if (!content || content.dataset.seeMoreInit) return;
  
        content.dataset.seeMoreInit = 'true';
  
        content.style.maxHeight = 'none';
        const fullHeight = content.scrollHeight;
  
        if (fullHeight <= COLLAPSED_HEIGHT) return;
  
        content.classList.add('is-collapsed');
  
        const btn = document.createElement('button');
        btn.className = 'see-more-btn';
        btn.textContent = 'See more';
  
        let expanded = false;
  
        btn.addEventListener('click', () => {
          expanded = !expanded;
          content.classList.toggle('is-collapsed');
          btn.textContent = expanded ? 'See less' : 'See more';
        });
  
        content.appendChild(btn);
      });
    }
  
    initSeeMore();
    document.addEventListener('shopify:section:load', initSeeMore);
    setTimeout(initSeeMore, 500);
  })();
  

  document.querySelectorAll('a[href*="#"]:not([href="#"])').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
  
      const offset = -130; // <-- change value here
  
      const currentPath = window.location.pathname.replace(/^\//, '');
      const anchorPath = this.pathname.replace(/^\//, '');
  
      if (currentPath === anchorPath && window.location.hostname === this.hostname) {
  
        let target = document.querySelector(this.hash);
  
        if (!target) {
          target = document.querySelector('[name="' + this.hash.slice(1) + '"]');
        }
  
        if (target) {
          e.preventDefault();
  
          const targetPosition = target.getBoundingClientRect().top + window.pageYOffset + offset;
  
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      }
    });
  });

  
};


document.addEventListener('click', function (e) {
  const wrapper = e.target.closest('.appstle_input_wrapper');
  if (!wrapper) return;

  const input = wrapper.querySelector('input');
  if (input) {
    input.click();
  }
});

function updatePreviewBarOffset() {
    const previewBar = document.getElementById('PBarNextFrameWrapper');

    if (previewBar) {
      const height = previewBar.offsetHeight;
      document.documentElement.style.setProperty(
        '--shopify-preview-bar-height',
        height + 'px'
      );
    } else {
      document.documentElement.style.setProperty(
        '--shopify-preview-bar-height',
        '0px'
      );
    }
  }

  window.addEventListener('load', updatePreviewBarOffset);
  window.addEventListener('resize', updatePreviewBarOffset);


  document.addEventListener('DOMContentLoaded', function () {

  if (window.location.pathname == '/pages/social-lead') {
    console.log('Here in LP');
    const killRedirect = function (e) {
      const link = e.target.closest('.menu-list__link[href="/"]');
      if (!link) return;

      // 🚫 HARD STOP
      e.preventDefault();
      e.stopImmediatePropagation();

      // also block inline handlers
      link.onclick = null;

      // 🎯 scroll instead
      const target = document.querySelector('#product-section'); // change this

      if (target) {
        window.scrollTo({
          top: target.offsetTop - 100,
          behavior: 'smooth'
        });
      }

      return false;
    };

    // attach everywhere possible
    document.addEventListener('click', killRedirect, true);
    document.addEventListener('pointerdown', killRedirect, true);
    document.addEventListener('mousedown', killRedirect, true);

  }

});